(function($) {

  function align_menu(){
    var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; 
    var windowHeight = $(window).height();
    var stickyHeaderHeight = $( '.stickyNavigation' ).outerHeight();  

    if( windowWidth < 741 ){
      $( "#page" ).css( "padding-top", stickyHeaderHeight + "px");

      if( $('body').hasClass('slideMenuTop') ){
        $('#slideMenu').css('top', "-" + windowHeight );
        $('#slideMenu > .wrapper').css('width', windowWidth );
      } else {
        $('#slideMenu').css('right', "-" + windowWidth );
        $('#slideMenu > .wrapper').css('width', windowWidth - 50 );

        if( $('#slideMenu').hasClass('open') ){
          $('#content').css( 'right',$('#slideMenu > .wrapper').width());
          $('#header').css( 'right',$('#slideMenu > .wrapper').width());
        }        
      }       
    } else {
      if( $('#header').hasClass('stickyNavigation') ){
        $( "#page" ).css( "padding-top", stickyHeaderHeight + "px");
      } else {
        $( "#page" ).css( "padding-top", "0");
      }      

      if( windowWidth > 900 ){
        $('html').removeClass('noScroll');
        $('#slideMenu').removeClass('open');
        $('#fade-overlay').removeClass('open');         
              
        if( $('body').hasClass('slideMenuTop') ){
          $('#slideMenu').css('top', "-" + windowHeight );
          $('#slideMenu > .wrapper').css('width', windowWidth );
          $('#menuButtonIcon').removeClass('icon-close');
          if( !$('#menuButtonIcon').hasClass('icon-menu') ){
            $('#menuButtonIcon').addClass('icon-menu'); 
          }          
        } else {

          if( $('#slideMenu').hasClass('open') ){
            $('#content').css('right', "0"  );
            $('#header').css('right', "0"  );
          }          
        }  
      } else {
        if( $('body').hasClass('slideMenuTop') ){
          $('#slideMenu').css('top', "-" + windowHeight );
          $('#slideMenu > .wrapper').css('width', windowWidth );
        } else {
          $('#slideMenu').css('right', "-300px");
          $('#slideMenu > .wrapper').css('width', "250px");

          if( $('#slideMenu').hasClass('open') ){
            $('#content').css('right', "250px"  );
            $('#header').css('right', "250px"  );
          }          
        }
      }     
    }
            
  } // align_menu()

$(document).ready(function(){ 

    align_menu();

    /*  Main menu slide.
    */
    $('.MenuButton .switch').click(function(event){
        event.preventDefault();

        $('html').toggleClass('noScroll');
        $('#fade-overlay').toggleClass('open'); 

        if( $('body').hasClass('slideMenuTop') ){
          $('#menuButtonIcon').toggleClass('icon-close');
          $('#menuButtonIcon').toggleClass('icon-menu');

          if( $('#slideMenu').hasClass('open') ){
            $('#slideMenu').animate({
                    top: "-" + $('#slideMenu').height() +'px'
                }, 400, function() {
                $(this).toggleClass('open').delay('800');
            });
          } else {
            $('#slideMenu').addClass('open').animate({
                    top: $('#header').outerHeight() +'px'
                }, {
                    duration: 300,
                    queue: false
                }, function() {
    
            });
          }          
        } else {
            $('#slideMenu').addClass('open').animate({
                    right:"0"
                }, {
                    duration: 300,
                    queue: false
                }, function() {
    
            });
            $('#content').animate({
                    right: $('#slideMenu > .wrapper').width()
                }, {
                    duration: 300,
                    queue: false
            });
            $('#header').animate({
                    right: $('#slideMenu > .wrapper').width()
                }, {
                    duration: 300,
                    queue: false
            });
        }
    });
    
    /*
        Close Main menu slide.
    */
    $('.close-slide > a').click(function(event){ 
        event.preventDefault();

        $('html').toggleClass('noScroll');
        $('#fade-overlay').toggleClass('open');

        if( $('body').hasClass('slideMenuTop') ){
            $('#slideMenu').animate({
                    top: "-" + $('#slideMenu').height() +'px'
                }, 400, function() {
                $(this).toggleClass('open').delay('800');
            });
        } else {
            $('#slideMenu').animate({
                    right: "-" + $('#slideMenu').width() +'px'
                }, 400, function() {
                $(this).toggleClass('open').delay('800');
            });
            $('#content').animate({
                    right: "0px"
                }, {
                    duration: 400,
                    queue: false                
            });
            $('#header').animate({
                    right: "0px"
                }, {
                    duration: 400,
                    queue: false  
            });
        }
    });

    /*
        Sub menus
    */
    $('.open-sub').click(function(event){ 
        event.preventDefault();
        $(this).children('.big-icon').toggleClass('icon-plus icon-minus');

        if( $(this).parent().hasClass('active') ){
            $(this).next().slideToggle( "fast", function() {
                $(this).parent().toggleClass('active'); 
            });
        }else{
            $('.first > .active > ul').slideToggle( "fast" , function() {
                $('.first > .active .big-icon').toggleClass('icon-plus icon-minus');
                $(this).parent().toggleClass('active');
            });
            $(this).next().slideToggle( "fast", function() {
                $(this).parent().toggleClass('active');
            });
        }
    
    });
    

    /*
        Search functions
    */
    $('.SearchButton.ready .switch').click(function(event){
        event.preventDefault();
        if( $(this).parent().hasClass('ready')){
            $(this).parent().removeClass('ready');
            formWidth = $( window ).width() - 330;
            $('#mainNavSearchForm').width(formWidth);
            $(this).parent().animate({
                width: "100%"
            }, 200, function() {
                    $('.close-mainSearch').fadeToggle('fast');
                    $( "#searchTextField" ).focus();    
                
            });
        }
    });

    $( "#searchTextField" ).keypress(function() {
        $(this).prev().removeClass('open');
    });

    $( "#searchTextField" ).focusout(function() {
        if( $(this).val() == '' ){
           $(this).prev().addClass('open'); 
        }
    });

    $('#mainNav .close-mainSearch').click(function(event){
        event.preventDefault();
        $('.SearchButton').addClass('ready');
        $(this).fadeToggle("fast", function() {
            $(this).parent().animate({
                    width: "70px"
                }, {
                    duration: 400,
                    queue: false  
            });
        });
    });

    $( "#SlideInput" ).focusin(function() {

        $( "#SlideSearch > span" ).animate({
                'margin-right': '70px'
            }  , 400, function() {
        $( "#slideMenu .cancel" ).css('display','block'); 
    });

        $( "#SearchResults" ).css('display','block').animate({
                height: "100%"
            }, {
                duration: 400,
                queue: false  
        });
    });

    $("#slideMenu .cancel").click(function(event){
        event.preventDefault(); 
        $( "#SearchResults" ).animate({
                height: "0px"
            }, {
                duration: 400,
                queue: false  
        }); 
        $( "#SlideSearch > span" ).animate({
                'margin-right': '0px'
            }, {
                duration: 400,
                queue: false  
        });
        $( this).css('display','none');
    });
    /*
        Footer buttons
    */
    $('#bottomMenuButton').click(function(event){ 
        event.preventDefault();
        $('#bottomMenuButton').toggleClass('open');
        $('#bottomMenuButton i').toggleClass('icon-arrow-down icon-arrow-up');
        $('.bottomMenu .menuItems').toggleClass('open');
    });
    $('.sharing-tools').hover( function(event){ 
        event.preventDefault();
        $('#sharethis').slideToggle();
    });


 
});


$( window ).resize(function() { 
    align_menu(); 
});

})(jQuery);    